<template>

    <drop-zone  ref="dz"
                id='item_photo_drop'
                :options="dropzoneOptions"
                v-on:vdropzone-removed-file="fileDelete"
                v-on:vdropzone-success="success"
                includeStyling=''
                :useCustomSlot=true>

            <div class="mt-2 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
                  <div class="space-y-1 text-center">
                    <svg class="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true">
                      <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                    <div class="text-2xl text-gray-600">
                      <label for="file-upload" class="relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">

                        <input id="file-upload" name="file-upload" type="file" class="sr-only">
                      </label>
                      <p class="pl-1">
                          Кликните тут или перетащите файлы прямо сюда</p>
                    </div>
                    <p class="text text-gray-500">
                      Прикладывайте фотографии в самом высоком разрешении и максимальном качестве, на сервере они будут автоматически сжаты до оптимального размера. (PNG, JPG до 10MB)
                    </p>
                  </div>
        </div>


    </drop-zone>

</template>

<script>
import DropZone from "./wrappers/DropZone";

export default {
    name: "PhotoUpload",
    components: {DropZone},
    props: {
        machineryItem: {
            type: Number,
            required: true,
        },
        maxFiles: {
            type:Number,
            default: 5,
            required: false,
        }
    },
    data: function () {
        return {
            dropzoneOptions: {
                url: '/api/machinery-photos/',
                params: {'machinery_item_id': this.machineryItem},
                // thumbnailWidth: 150,
                // thumbnailHeight: 400,
                addRemoveLinks: true,
                maxFilesize: 20, // MB
                acceptedFiles: '.jpg, .jpeg',
                maxFiles: this.maxFiles,
                dictDefaultMessage: "Перетащите файлы для загрузки в это поле",
                dictFallbackMessage: "К сожалению, ваш браузер не поддерживает Drag'n'Drop",
                dictFallbackText: "Пожалуйста, воспользуйтесь старой доброй формой для загрузки",
                dictFileTooBig: "Файл слишком большой({{filesize}}MB). Максимальный допустимый размер файла {{maxFilesize}}MB",
                dictInvalidFileType: "Только фотографии в формате JPEG.",
                dictResponseError: "Произошла ошибка при загрузке файла. Попробуйте еще раз. Если ошибка будет повторяться - передайте эту информацию администратору сайта: Код ошибки {{statusCode}}",
                dictCancelUpload: "Отменить загрузку",
                dictCancelUploadConfirmation: "Уверены, что хотите прервать загрузку?",
                dictRemoveFile: "Удалить файл",
                dictRemoveFileConfirmation: null,
                dictMaxFilesExceeded: "Превышен лимит количества файлов. Вы можете загрузить не более {{maxFiles}}",
                headers: {
                    'X-CSRF-TOKEN':  document.querySelector('meta[name="csrf-token"]').content
                },

            },
        }
    },
    mounted: function () {

        let vm =this;
        axios.get('/api/machinery-photos/' + this.machineryItem).then(function(data){

            data.data.forEach(function ($item){
                 vm.$refs.dz.manuallyAddFile($item.file, $item.url);
            });

        }).catch(function(error){
            console.log(error);
        });

    },
    methods: {
        fileDelete(file){
             // axios.delete ('/api/machinery-photos/' + file.name);

            let name = file.previewElement.querySelector('[data-dz-name]').innerHTML;
            axios.delete ('/api/machinery-photos/' + name);
            // console.log(file);
        },
        success (file, response) {
            // let obj = JSON.parse(response);
                 //    alert(response.filename); // <---- here is your filename

           // file.previewElement.querySelector("img").src = response.filename;


            var f = file.previewElement.querySelector("[data-dz-name]");
            f.innerHTML = response.filename;
        }
    }
}
</script>

<style scoped>

</style>
